import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchUserDiscountCards, getIsLoadedCards, getUserDiscountCards, getIsErrorCards } from '@entities/Discount';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useCallback, useEffect } from 'react';
import { SkeletonLoading, WrapperLk, WrapperErrorLkShort } from '@app/shared';
import { IconChevronRight } from '@koleso-icons';
import classNames from 'classnames';
import IconDiscountValue from './icons/DiscountCardValue.svg';
import IconDiscount from './icons/DiscountCard.svg';

import styles from './ShortInfoUserDiscountCard.module.scss';

export const ShortInfoUserDiscountCard = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isMobile = useWindowSizing(990);
  const isLoaded = useAppSelector(getIsLoadedCards);
  const cards = useAppSelector(getUserDiscountCards);
  const isError = useAppSelector(getIsErrorCards);

  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchUserDiscountCards());
    }
  }, []);

  const handlerRoute = useCallback(async () => {
    await router.push('/personal/discount/');
  }, []);

  const handlerRouteMobile = useCallback(async () => {
    isMobile && (await router.push('/personal/discount/'));
  }, [isMobile]);

  if (isError) {
    return (
      <WrapperLk className={classNames(styles.Wrapper)} IsMobile={isMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Дисконтная программа
            <IconChevronRight width={16} height={16} />
          </div>
          <WrapperErrorLkShort error={isError} className={styles.Error} />
        </div>
      </WrapperLk>
    );
  }

  if (!isLoaded) {
    return <SkeletonLoading className={styles.WrapperSkeleton} width={'100%'} height={'100%'} />;
  }

  if (isLoaded && !cards?.cardNum) {
    return (
      <WrapperLk className={classNames(styles.Wrapper)} IsMobile={isMobile} onClick={handlerRouteMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Дисконтная программа
            <IconChevronRight width={16} height={16} />
          </div>
          <div onClick={handlerRoute} className={styles.DiscountText}>
            Будет доступна после первой покупки
          </div>
        </div>
        <div className={styles.IconWrapperDiscount}>
          <IconDiscount width={90} height={90} />
        </div>
      </WrapperLk>
    );
  }

  return (
    <WrapperLk className={classNames(styles.Wrapper, styles.IsDiscountCard)} IsMobile={isMobile} onClick={handlerRouteMobile}>
      <div className={styles.Container}>
        <div className={styles.Title} onClick={handlerRoute}>
          {isMobile ? 'Моя скидка в центрах' : 'Дисконтная программа'}
          <IconChevronRight width={16} height={16} />
        </div>
        <div onClick={handlerRoute} className={styles.DiscountText}>
          {isMobile ? `до ${cards.serv}%` : 'Мои скидки в центрах Колесо.ру'}
        </div>
      </div>
      <div className={styles.IconWrapperDiscount}>
        <IconDiscountValue width={90} height={90} />
        <div>
          <span>до</span> {cards.serv}%
        </div>
      </div>
    </WrapperLk>
  );
};
